module.exports = __webpack_public_path__ + "static/media/teacher14.519d6bee.png";